import React, { Fragment } from 'react';
import { CheckboxItem, Collapse, Col } from 'seduo-ui';
class CheckboxList extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            isExpanded: false,
        };
        this.toggle = () => {
            this.setState({
                isExpanded: !this.state.isExpanded,
            });
        };
    }
    render() {
        const { title, items, type, expandLimit } = this.props;
        const { isExpanded } = this.state;
        const visibleItems = items.slice(0, expandLimit);
        const expandItems = items.slice(expandLimit);
        return (<Col md={6} lg={4} className="mb-8">
                <h5>{title}</h5>
                {visibleItems.map((item, index) => (<CheckboxItem index={`checkbox_item_${type}_${index}`} title={item.title} count={item.count} stars={item.stars} key={index}/>))}

                {expandItems.length > 0 && (<Fragment>
                        <Collapse isOpen={isExpanded}>
                            {expandItems.map((item, index) => (<CheckboxItem index={`checkbox_item_${type}_${expandLimit + index}`} title={item.title} count={item.count} stars={item.stars} key={index}/>))}
                        </Collapse>
                        <span className="link mt-4 d-block" onClick={this.toggle}>
                            {isExpanded ? 'Zobrazit méně' : 'Zobrazit další'}
                        </span>
                    </Fragment>)}
            </Col>);
    }
}
CheckboxList.defaultProps = {
    expandLimit: 5,
};
export default CheckboxList;
